import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';

export const elLocaleMap = {
    'zh-CN': zhCn,
    en: en,
};

export enum LocaleTypeEnum {
    English = 'en',
    Chinese = 'zh-CN',
}

export type LocaleType = 'zh-CN' | 'en'; //语言类型

export interface LocaleOptionType {
    // 语言配置选项
    value: LocaleType;
    label?: string;
}

interface LocaleState {
    currentLocale: LocaleTypeEnum;
    localeOption: LocaleOptionType[];
}

const useLocaleStore = defineStore({
    id: 'locales',
    state: (): LocaleState => {
        return {
            currentLocale: LocaleTypeEnum.Chinese,
            // 多语言
            localeOption: [
                {
                    value: 'zh-CN',
                    label: '中',
                },
                {
                    value: 'en',
                    label: 'En',
                },
            ],
        };
    },
    getters: {
        isChinese(): boolean {
            return this.currentLocale === LocaleTypeEnum.Chinese;
        },
        getCurrentLocale(): LocaleTypeEnum {
            return this.currentLocale;
        },
        getLocaleOption(): LocaleOptionType[] {
            return this.localeOption;
        },
    },
    actions: {
        setCurrentLocale(localeType: LocaleTypeEnum) {
            this.currentLocale = localeType;
        },
    },
    persist: {
        storage: localStorage,
        paths: ['currentLocale'],
    },
});

export default useLocaleStore;
